import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Checkbox from '../Checkbox';

import styles from './styles.scss';

const CheckboxList = ({ data, handleChange, isChecked, id: parentId, isLabelLeft }) => (
  <ul className={classnames(styles.list)}>
    {data.map((item) => {
      const renderCount = !!item.count || item.count === 0;
      return (
        <li key={`${item.id}-${parentId}`}>
          <Checkbox
            id={`${item.id}-${parentId}`}
            value={item.id}
            onChange={(ev) => handleChange(ev, item)}
            labelContent={() => (
              <span>
                {item.name} {renderCount && <span className={styles.count}>({item.count})</span>}
              </span>
            )}
            isMuted={item.count === 0}
            isChecked={isChecked(item)}
            isLabelLeft={isLabelLeft}
          />
        </li>
      );
    })}
  </ul>
);

CheckboxList.defaultProps = {
  isChecked: () => {},
  isLabelLeft: false,
};

CheckboxList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      count: PropTypes.number,
    }).isRequired,
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
  isChecked: PropTypes.func,
  id: PropTypes.string.isRequired,
  isLabelLeft: PropTypes.bool,
};

export default CheckboxList;
